import axios from 'axios';

export default {
  FETCH_FAQS ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('common/getAllFaqs')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('faqs', JSON.stringify(payload));
                    commit('SET_FAQS', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDFAQ ({ commit }, faqId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`common/getAllFaqs`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;
            console.log('payload', payload)
            let selectedFaq = payload.filter(x => {
              return x.faqId.toString() === faqId.toString()
            });

            console.log('found FAQ', selectedFaq)
            commit('SET_SELECTED_FAQ', selectedFaq[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_FAQ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add FAQ payload : ", payload);
            axios.post('common/insertFaqs', payload)
                .then((response) => {
                    console.log('ADD_FAQ action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_FAQ action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    UPDATE_FAQ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.post('/common/updateFaqs', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_FAQ action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/faqs/actions.js